"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Mock = void 0;
class Mock {
}
exports.Mock = Mock;
//# sourceMappingURL=mock.js.map